import { render, staticRenderFns } from "./NewRingAuthForm.vue?vue&type=template&id=9aa3f218&scoped=true&"
import script from "./NewRingAuthForm.vue?vue&type=script&lang=js&"
export * from "./NewRingAuthForm.vue?vue&type=script&lang=js&"
import style0 from "./NewRingAuthForm.vue?vue&type=style&index=0&id=9aa3f218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa3f218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4282463623/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aa3f218')) {
      api.createRecord('9aa3f218', component.options)
    } else {
      api.reload('9aa3f218', component.options)
    }
    module.hot.accept("./NewRingAuthForm.vue?vue&type=template&id=9aa3f218&scoped=true&", function () {
      api.rerender('9aa3f218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Authorizations/NewRingAuthForm.vue"
export default component.exports